<template>
  <b-modal id="modal-google-calendar" hide-footer scrollable>
    <template #modal-header>
      <h4>
        {{
          data.id === null
            ? $t("colleges.google-calendar.new")
            : $t("colleges.google-calendar.edit")
        }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row class="justify-content-md-center">
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.google-calendar.name')"
              label-for="name"
            >
              <ValidationProvider
                :name="$t('colleges.google-calendar.name')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.name"
                  type="text"
                  :placeholder="$t('colleges.google-calendar.name')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.google-calendar.calendar_id')"
              label-for="calendar_id"
            >
              <ValidationProvider
                :name="$t('colleges.google-calendar.calendar_id')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.calendar_id"
                  type="text"
                  :placeholder="$t('colleges.google-calendar.calendar_id')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="col-md-12"
              :label="$t('colleges.google-calendar.api_key')"
              label-for="calendar_id"
            >
              <ValidationProvider
                :name="$t('colleges.google-calendar.api_key')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.api_key"
                  type="text"
                  :placeholder="$t('colleges.google-calendar.api_key')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </b-row>
          <hr />
          <b-button
            :disabled="calendarLoading"
            variant="success"
            class="float-right"
            type="submit"
          >
            <span v-if="calendarLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-google-calendar')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "modalFormGoogleCalendar",
  mounted() {
    core.index();
  },
  data() {
    return {
      data: {
        id: null,
        name: null,
        calendar_id: null,
        api_id: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "updateOrCreateCollegeGoogleCalendar",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.data = {
          id: item.id,
          name: item.name,
          api_key: item.api_key,
          calendar_id: item.calendar_id,
        };
      }
      this.$bvModal.show("modal-google-calendar");
    },
    async onSubmit() {
      const resp = await this.saveForm(this.data);
      this.$bvModal.hide("modal-google-calendar");
      this.$emit("refresh");
      if (resp.status === 201 || resp.status === 200) {
        core.showSnackbar(
          "success",
          !this.data.id
            ? this.$t("app.success-create")
            : this.$t("app.success-edit")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.data = {
        id: null,
        name: null,
        calendar_id: null,
        api_id: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      calendarLoading: "calendarLoading",
    }),
  },
};
</script>
